import React, { useRef, useState, useMemo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkAlt, faPencilAlt} from "@fortawesome/free-solid-svg-icons";
import { Formik } from "formik";
import { toast } from "react-toastify";
import { RestAPI } from "@aws-amplify/api-rest";
import LoadingDialog from "../Utils/LoadingDialog";
import SelfHelp from "../Utils/SelfHelp";
import withName from "../../hoc/withName";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router";

import { FilterMatchMode } from "primereact/api";

import { Tooltip } from "primereact/tooltip";
import DataTablePrime from "../PrimeComponents/DataTablePrime";
import ButtonPrime from "../PrimeComponents/ButtonPrime";
import DropdownPrime from "../PrimeComponents/DropdownPrime";
const BillingClientParamsForm = () => {

    const { t, i18n } = useTranslation();
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [originalValues, setOriginalValues] = useState(null);
    const [clientInfo, setClientInfo] = useState(null);
    const [data, setData] = useState(null);
    const [hubs, setHubs] = useState([]);
    const [onEdit, setOnEdit] = useState(false);
    const [pricesLists, setPricesLists] = useState([]);
    const formikRef = useRef(null);
    const selfHelpDescarga = [{
        tab: 1, header: { text: t("selfHelp.instructions") }, params:[]
    }];
    const names = useMemo(() => [
        t("billing.clientParamsPage.table.account"),
        t("billing.clientParamsPage.table.farm"),
        t("billing.clientParamsPage.table.ncliente"),
    ], [t]);
    useEffect(() => {
        if(id && data===null){
            RestAPI.get("apiAdminDropControl","/billing/clientparams",
                {queryStringParameters: {"clientId":id}}).then(async (response) => {
                setClientInfo(response?.[0]?.result?.clientInfo[0]);
                setData(response?.[0]?.result?.farms);
                setHubs(response?.[0]?.result?.hubs);
                setPricesLists(response?.[0]?.result?.lists);
                setIsLoading(false);
            })
                .catch((error) => {
                    setIsLoading(false);
                    console.log(error);
                });
        }
        if(formikRef.current && clientInfo && !formikRef.current.n_cliente_id){
            formikRef.current && formikRef.current.setFieldValue("hub_id",clientInfo?.hub_id);
            formikRef.current && formikRef.current.setFieldValue("lista_precio_id",clientInfo?.lista_precio_id);
            formikRef.current && formikRef.current.setFieldValue("n_cliente_id",clientInfo?.n_cliente_id);
        }
    },[data, id, formikRef, clientInfo]);
    const navigate = useNavigate();
    const farmParamsTemplate = (rowData) =>{
        return (
            <>
                <Tooltip target={`.custom-target-icon-${rowData.campo_id}`} />
                <FontAwesomeIcon
                    data-pr-tooltip={t("billing.farmBillingParams")}
                    data-pr-position="left"
                    id="nextStatusIcon"
                    name="nextStatusIcon"
                    className={`btnEdit pointer custom-target-icon-${rowData.campo_id}`}
                    size="lg" style={{ color: "blue", marginRight :"15px" }}
                    icon={faExternalLinkAlt}
                    onClick={(e) => {navigate({ pathname: "/farms/billingparams", search:`?farm=${rowData.campo_id}` });}}
                >
                    {t("billing.farmBillingParams")}
                </FontAwesomeIcon>
            </>
        );
    };
    return (
        isLoading?<LoadingDialog />
            :<div className='row-container'>
                <Formik innerRef={formikRef}
                    initialValues={{
                    }}
                    validate={(data) => {
                        const errors = {};
                        return errors;
                    }}
                    onSubmit={async (formData) => {
                        setIsLoading(true);
                        await RestAPI.put("apiAdminDropControl", "/billing/clientparams", {body: {...formData, "type":"update"}}).then(async (response) => {
                            setIsLoading(false);
                            formikRef.current && formikRef.current.setFieldValue("hub_id",formData?.hub_id);
                            formikRef.current && formikRef.current.setFieldValue("lista_precio_id",formData?.lista_precio_id);
                            formikRef.current && formikRef.current.setFieldValue("n_cliente_id",formData?.n_cliente_id);
                            toast.success(t("billing.billingparamsSuccess"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                            setOnEdit(false);
                            setOriginalValues(formikRef?.current?.values);
                        })
                            .catch((error) => {
                                setIsLoading(false);
                                console.log(error);
                                toast.error(t("billing.billingparamsError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                            });
                    }}
                >
                    {({handleSubmit, values, setFieldValue}) => (
                        <>
                            {
                                hubs && pricesLists?
                                    <div className='row'>
                                        <div className="col-xl-12 col-lg-12 col-sm-12">
                                            <div id="cardRaw" className="card">
                                                <div className="card-body">
                                                    <div className='row'>
                                                        <div className='col col-sm-2 col-md-3 col-lg-3'>
                                                            {false && selfHelpDescarga &&
                                                                <SelfHelp t={t} lng={i18n.language} params={selfHelpDescarga} fertiTable />}
                                                        </div>
                                                        <div className='col col-sm-10 col-md-8 col-lg-6 text-center'>
                                                            <h5 className="card-title"><span>{t("billing.billingparams")}</span></h5>
                                                        </div>
                                                        <div className='col col-sm-3 col-md-3 col-lg-3 d-flex justify-content-end align-items-right align-items-center'>
                                                            {
                                                                !onEdit?
                                                                    <>
                                                                        <FontAwesomeIcon icon={faPencilAlt} style={{ color: "grey", fontSize:"1.65rem", marginRight:"15px", cursor:"pointer" }} onClick={(event) => {
                                                                            event.preventDefault();
                                                                            setOriginalValues({...formikRef?.current?.values});
                                                                            setOnEdit(true);
                                                                        }}
                                                                        >{t("forms.edit")}</FontAwesomeIcon>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <ButtonPrime t={t} template="formSave" onClick={handleSubmit} tooltip={t("forms.save")} tooltipOptions={{ className:"tooltip-prime", position:"bottom"}} />
                                                                        <ButtonPrime t={t} template="formCancel"
                                                                            tooltip={t("forms.cancel")} tooltipOptions={{ className:"tooltip-prime", position:"bottom"}}
                                                                            onClick={() => {
                                                                                formikRef.current && formikRef.current.setFieldValue("hub_id",originalValues?.hub_id);
                                                                                formikRef.current && formikRef.current.setFieldValue("lista_precio_id",originalValues?.lista_precio_id);
                                                                                formikRef.current && formikRef.current.setFieldValue("n_cliente_id",originalValues?.n_cliente_id);
                                                                                setOriginalValues(null);
                                                                                setOnEdit(false);
                                                                            }}
                                                                        />
                                                                    </>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className='linea-titulo' />

                                                    <div className="row">

                                                        <div className="row linea-formulario col-12 text-center">
                                                            <div className="col-8 col-md-4 text-sm-left mtem-05">
                                                                <label className="boldie">{t("billing.nCliente")}</label>
                                                            </div>
                                                            <div className="col-8 col-md-8 col-lg-6 text-sm-left mtem-05">
                                                                <label className='boldie'>{values?.n_cliente_id}</label>
                                                            </div>
                                                        </div>
                                                        <div className="row linea-formulario col-12 text-center">
                                                            <div className="col-8 col-md-4 text-sm-left mtem-05">
                                                                <label className="boldie">{t("billing.sideBar.priceList")}</label>
                                                            </div>
                                                            <div className="col-8 col-md-8 col-lg-6 text-sm-left mtem-05">
                                                                {
                                                                    !onEdit?
                                                                        <label className='boldie'>{pricesLists?.find((e) => e.lista_precio_id === values?.lista_precio_id)?.nombre}</label>
                                                                        :
                                                                        <DropdownPrime
                                                                            value={pricesLists?.find((e) => e.lista_precio_id === values?.lista_precio_id)}
                                                                            onChange={(e) => {
                                                                                setFieldValue("lista_precio_id",e?.value?.lista_precio_id);
                                                                            }}
                                                                            options={pricesLists} optionLabel="nombre"
                                                                            placeholder={t("billing.sideBar.priceList")}
                                                                        />
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="row linea-formulario col-12 text-center">
                                                            <div className="col-8 col-md-4 text-sm-left mtem-05">
                                                                <label className="boldie">{t("billing.hub")}</label>
                                                            </div>
                                                            <div className="col-8 col-md-8 col-lg-6 text-sm-left mtem-05">
                                                                {
                                                                    !onEdit?
                                                                        <label className='boldie'>{hubs?.find((e) => e.hub_id === values?.hub_id)?.nombre}</label>
                                                                        :
                                                                        <DropdownPrime
                                                                            value={hubs?.find((e) => e.hub_id === values?.hub_id)}
                                                                            onChange={(e) => {
                                                                                setFieldValue("hub_id",e?.value?.hub_id);
                                                                            }}
                                                                            options={hubs} optionLabel="nombre"
                                                                            placeholder={t("billing.hub")}
                                                                        />
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :null
                            }
                        </>
                    )}
                </Formik>
                <div className='row'>
                    <div className="col-xl-12 col-lg-12 col-sm-12">
                        <div id="cardRaw" className="card">
                            <div className="card-body">
                                <div className='row'>
                                    <div className='col col-sm-2 col-md-3 col-lg-3'>
                                        {false && selfHelpDescarga &&
                                        <SelfHelp t={t} lng={i18n.language} params={selfHelpDescarga} fertiTable />}
                                    </div>
                                    <div className='col col-sm-10 col-md-8 col-lg-6 text-center'>
                                        <h5 className="card-title"><span>{t("billing.clientFarms")+id}</span></h5>
                                    </div>
                                    <div className='col col-sm-3 col-md-3 col-lg-3 d-flex justify-content-end align-items-right align-items-center' />
                                    <div className="col-12 text-center">
                                        <div className="row linea-formulario">
                                            <DataTablePrime
                                                t={t}
                                                header="search"
                                                items={data}
                                                scrollHeight="55vh"
                                                paginator rows={10} rowsPerPageOptions={[10, 25, 50]}
                                                filters={{
                                                    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                                                    n_cliente_id: { value: null, matchMode: FilterMatchMode.EQUALS },
                                                    razon_social: { value: null, matchMode: FilterMatchMode.CONTAINS },
                                                    nombre: { value: null, matchMode: FilterMatchMode.CONTAINS },
                                                }}
                                                size="small"
                                                globalFilterFields={["razon_social", "nombre"]}
                                                fields={[
                                                    {field:"razon_social",header:names[0], bodyStyle:{textAlign:"center"}},
                                                    {field:"nombre",header:names[1], bodyStyle:{textAlign:"center"}},
                                                    {field:"n_cliente_id",header:"", body:farmParamsTemplate, bodyStyle:{textAlign:"center"}},
                                                ]}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    );
};

export default withName(BillingClientParamsForm, "BillingClientParamsForm");
